module.exports = __webpack_public_path__ + "img/rujia_4.ae9d183d.png";